import moment from "moment";

export const getFormattedDate = (date: string, format: string) => {
    return moment(date).format(format);
}